module.exports = __webpack_public_path__ + "media/05.b792db00.mp4";